import { ICouponApplied } from 'types/coupon';
import { getCouponScope } from 'services/coupon/type';
import { couponScopeConst } from 'config/coupon';

export const classifyCouponByShop = (coupon: ICouponApplied[]) => {
    const newData: Record<string, ICouponApplied[]> = {};
    coupon.forEach((item) => {
        if (getCouponScope(item) === couponScopeConst.platform) {
            createNewKey(newData, 'platform', item);
        } else {
            createNewKey(newData, item.shopId, item);
        }
    });

    return newData;
};

export const classifySelectedCouponByShop = (coupon: ICouponApplied[], isSingle: false) => {
    const newData: Record<string, ICouponApplied> = {};
    coupon.forEach((item) => {
        if (item.selected) {
            if (getCouponScope(item) === couponScopeConst.platform) {
                newData.platform = item;
            } else if (isSingle) {
                newData.shop = item;
            } else {
                newData[item.shopId] = item;
            }
        }
    });

    return newData;
};

function createNewKey(obj: Record<string, any[]>, key: string, value: any) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        obj[key].push(value);
    } else {
        obj[key] = [value];
    }
}
